// src/components/owners/OwnerActionsMenu.jsx
import React, { useState, useRef, useEffect } from 'react';
import { MoreVertical, FileText, Key, MessageCircle, Trash2 } from 'lucide-react';

const OwnerActionsMenu = ({ owner, onEdit, onDelete, onOpenNotes, onResetPassword }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuPosition, setMenuPosition] = useState('bottom');
  const buttonRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      const buttonRect = buttonRef.current?.getBoundingClientRect();
      const menuHeight = 200;
      const spaceBelow = window.innerHeight - (buttonRect?.bottom || 0);
      const spaceAbove = buttonRect?.top || 0;
      
      if (spaceBelow < menuHeight && spaceAbove > menuHeight) {
        setMenuPosition('top');
      } else {
        setMenuPosition('bottom');
      }
    }
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && 
          buttonRef.current && !buttonRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative inline-block">
      <button
        ref={buttonRef}
        onClick={() => setIsOpen(!isOpen)}
        className="p-1 text-gray-400 hover:text-white rounded-lg transition"
      >
        <MoreVertical size={18} />
      </button>

      {isOpen && (
        <div
          ref={menuRef}
          className={`absolute right-0 w-48 bg-gray-800 border border-gray-700 rounded-lg shadow-lg z-50 ${
            menuPosition === 'top' ? 'bottom-full mb-1' : 'top-full mt-1'
          }`}
        >
          <div className="py-1">
            <button
              onClick={() => {
                setIsOpen(false);
                onOpenNotes();
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
            >
              <MessageCircle size={14} /> Add Note / History
            </button>
            
            <button
              onClick={() => {
                setIsOpen(false);
                onEdit();
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
            >
              <FileText size={14} /> Edit Client
            </button>
            
            <button
              onClick={() => {
                setIsOpen(false);
                onResetPassword();
              }}
              className="w-full px-4 py-2 text-left text-sm text-gray-300 hover:bg-gray-700 flex items-center gap-2"
            >
              <Key size={14} /> Reset Password
            </button>
            
            <hr className="my-1 border-gray-700" />
            
            <button
              onClick={() => {
                setIsOpen(false);
                onDelete();
              }}
              className="w-full px-4 py-2 text-left text-sm text-red-400 hover:bg-gray-700 flex items-center gap-2"
            >
              <Trash2 size={14} /> Delete / Deactivate
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default OwnerActionsMenu;